export default __webpack_public_path__ + "static/media/DP6 2A-4D-2EC.f1709e71.jpg";